/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type CustomerSubscriptionData_CustomerFragment = { __typename: 'Customer', displayCount: number, waveSubscriptionUsage?: number | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null };

export type CustomersGridItem_CustomerFragment = { __typename: 'Customer', id: string, handle: string, name: string, avatarUrl?: string | null, displayCount: number, waveSubscriptionUsage?: number | null, displayUsage?: { __typename: 'UsageStatistics', presence: { __typename: 'PresenceStatistics', disconnected: number }, powerState: { __typename: 'PowerStateStatistics', unplannedStandBy: number }, warnings: { __typename: 'WarningStatistics', emptyShadowWarnings: number, recommendedSettingsWarnings: number, undefinedRecommendedSettingsWarnings: number, outOfSyncPowerScheduleWarnings: number, outOfSyncPlaylistWarnings: number, playlistSyncFailedWarnings: number, powerScheduleSyncFailedWarnings: number, outOfSyncScheduleWarnings: number, scheduleSyncFailedWarnings: number } } | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null };

export const CustomerSubscriptionData_CustomerFragmentDoc = gql`
    fragment CustomerSubscriptionData_customer on Customer {
  displayCount
  waveSubscriptionUsage
  waveSubscription {
    id
    usage {
      current
      max
    }
  }
  waveSubscriptions {
    id
    validUntil
    usage {
      current
      max
    }
    status
  }
}
    `;
export const CustomersGridItem_CustomerFragmentDoc = gql`
    fragment CustomersGridItem_customer on Customer {
  id
  handle
  name
  avatarUrl
  displayCount
  displayUsage {
    presence {
      disconnected
    }
    powerState {
      unplannedStandBy
    }
    warnings {
      emptyShadowWarnings
      recommendedSettingsWarnings
      undefinedRecommendedSettingsWarnings
      outOfSyncPowerScheduleWarnings
      outOfSyncPlaylistWarnings
      playlistSyncFailedWarnings
      powerScheduleSyncFailedWarnings
      outOfSyncScheduleWarnings
      scheduleSyncFailedWarnings
    }
  }
  ...CustomerSubscriptionData_customer
}
    ${CustomerSubscriptionData_CustomerFragmentDoc}`;